module.exports = __webpack_public_path__ + "static/media/issue-blue.834f6f7e.svg";